import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useFeature } from '@growthbook/growthbook-react';
import { Loader as ModulorLoader } from '@modulor/react';
import LoaderSCCOM from '../../AppSCCOM/components/Loader';
import { useSelector } from 'react-redux';
import { ReactComponent as LoadingNomad } from '../../assets/icons/loading_nomad_new.svg'; // no modulor icon
import { brandSelector } from '../../redux/reducers/app/params';
import { getDataTestAttrs } from '../../utils/testing-locators';
import { useIsSSCOMBrand } from '../../hooks/useIsSSCOMBrand';
import { LOADER, LOADER_NO_NAME_BRANDS } from '../../constants/dataTestIds';
import {
  NO_NAME_BRANDS,
  NOMAD_GROUP_BRANDS,
} from '../../constants/noNameBrands';
import FEATURES from '../../constants/featureToggling';
import styles from './Loader.module.css';

const Loader = ({ className, width = 50, height = 50 }) => {
  const brand = useSelector(brandSelector);
  const isIncognito = useFeature(FEATURES.USE_INCOGNITO_BRAND).on;
  const isSCCOMBrand = useIsSSCOMBrand();

  const returnBrandedLoader = () => {
    if (NOMAD_GROUP_BRANDS.includes(brand)) {
      return <LoadingNomad width={width} height={height} />;
    }
    if (isSCCOMBrand) {
      return <LoaderSCCOM />;
    }
    if (NO_NAME_BRANDS.includes(brand) || isIncognito) {
      return (
        <i
          className={styles.loader}
          style={{ width, height }}
          {...getDataTestAttrs(LOADER_NO_NAME_BRANDS)}
        />
      );
    }

    return <ModulorLoader size={'large'} />;
  };

  return (
    <div
      className={classNames(styles.component, className, {
        [styles['component-sccom']]: isSCCOMBrand,
      })}
      {...getDataTestAttrs(LOADER)}
    >
      {returnBrandedLoader()}
    </div>
  );
};

Loader.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default Loader;
